module.exports = __webpack_public_path__ + "img/Feature.fb246c7b.jpg";